const translationJsonObj = require('libs-content-helper').EnTranslations;

var translationJson = {
    "LEARNER": {
        "ACTIVITYLAUNCH": {
            "_url": "https://nemo2.comprodls.com/:spaceid/product/:productcode",
            "DOWNLOAD_INSTRUCTIONS1": "Download the",
            "DOWNLOAD_INSTRUCTIONS2": "below and complete this activity",
            "DOWNLOAD": "Download",
            "SUBMITTED_FOR_MARKING": "Submitted",
            "FEEDBACK_READY_MSG": "We'll let you know when your teacher has marked your work",
            "SUBMITTED": "Submitted",
            "ARE_YOU_READY_TO_SUBMIT": "Ready to submit?",
            "ARE_YOU_READY_TO_SUBMIT_GROUP":"Ready to submit your group's work?",
            "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "Just so you know, it won't be possible to make any changes to your work after it's submitted",
            "NO_FURTHER_CHANGES_ALLOWED_GROUP_MSG": "You are acting for all group members. It won't be possible to change your work later unless your teacher requests it",
            "CANCEL": "Cancel",
            "SUBMIT": "Submit",
            "YES_SUBMIT": "Yes, Submit",
            "CLASS_NOT_STARTED_MSG": "Your class hasn't started yet",
            "SAVE_DRAFT_AFTER_CLASS_STARTS": "You can save a draft now and submit to the teacher when your class starts",
            "SAVE": "Save",
            "SAVED": "Saved",
            "AUTO_SAVED": "Auto-saved",
            "COMPLETED": "Completed",
            "START_RECORDING_MSG1": "Tap to start recording",
            "START_RECORDING_MSG2": "You can play it once stopped",
            "PLAY_RECORDING_MSG1": "Play your recording",
            "PLAY_RECORDING_MSG2": "Time recorded: {{elapsedTime}}",
            "STOP_PLAYING_MSG1": "Stop playing",
            "STOP_PLAYING_MSG2": "Time: {{audioSeeker}}/{{duration}}",
            "START_NEW_RECORDING_MSG1": "Start new recording",
            "START_NEW_RECORDING_MSG2": "This will replace the old one",
            "RECORDING": "Recording",
            "STOP_RECORDING_MSG1": "Stop recording",
            "STOP_RECORDING_MSG2": "Time elapsed: {{elapsedTime}}",
            "SEC_LEFT": " sec left",
            "SUBMITTING_MSG1": "Submitting recording ...",
            "SAVING_MSG1": "Saving recording ...",
            "PROCESSING_MSG": "Processing recording ...",
            "SUBMITTED_RECORDING": "Play your recording",
            "RECORDED": "Recorded",
            "FORGIVE_US_TEXT_MSG1": "Sorry ...",
            "RECORDING_NOT_POSSIBLE_MSG1": "We're unable to record your work at the moment",
            "RECORDING_NOT_POSSIBLE_MSG2": "This may be because you're offline, your microphone is not connected, or because your browser does not support recording. Check that you're online and your microphone is on, or try again using a different browser (we suggest Chrome, Firefox or Safari), and/or a different device (tablet or desktop)",
            "OK": "OK",
            "NEXT": "Next",
            "CHECK": "Check",
            "PREVIOUS": "Previous",
            "FIRST_ATTEMPT":"First attempt",
            "SECOND_ATTEMPT":"Second attempt",
            "THIRD_ATTEMPT":"Third attempt",
            "SCORE":"Score :",
            "NO_FEEDBACK": "No feedback",
            "MARKED_AT": "Marked {{elapsedTime}} at {{timestamp}}",
            "MARK" : "Score:",
            "FEEDBACK" : "Feedback:",
            "NEW_SUBMISSION_REQUESTED": "New submission requested",
            "WORDS": "words",
            "WORD_COUNT": "Word count: ",
            "ANSWER": "Answer:",
            "ANSWER_LABEL": "Answer",
            "TYPE_HERE": "Type here ...",
            "NEXT_ACTIVITY": "NEXT ACTIVITY",
            "REVIEW": "REVIEW",
            "BACK": "BACK",
            "TITLE" : "Collaborative Task",
            "MODAL_PLACEHOLDER" : "This is a collaborative task, where students assigned to a group work together to complete an activity. Students need to be in a group to do this",
            "DISABLE_GROUP_INFO_MSG" : "This is a collaborative activity. It can only be completed by students assigned to groups by a teacher",
            "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "The activity is now locked because the group that worked on this has now been archived. You can still see the submitted work and the feedbacks from the teacher.",
            "ARCHIVED_LOCK_VERSION_MSG" : "The activity is now locked because the group that worked on this has now been archived.",
            "ON_BEHALF_OF": "on behalf of",
            "ON_BEHALF_OF_STUDENT_NOT_PRESENT": "A student not in the group submitted on behalf of",
            "GROUP_PSKILL_TITLE": "Title:",
            "ADD_LINK": "Add link",
            "EDIT_LINK": "Edit link",
            "REMOVE_LINK": "Remove link",
            "URL": "URL",
            "URL_PLACEHOLDER": "Enter the destination link",
            "URL_REQUIRED": "URL is required",
            "URL_INVALID": "Enter a valid URL",
            "URL_HELP_TEXT": "(max 256 characters are allowed)",
            "OPTIONAL_TEXT": "Text to display (optional)",
            "OPTIONAL_TEXT_PLACEHOLDER": "Enter the text to display",
            "UPDATE_LINK": "Edit link",
            "ARE_YOU_SURE": "Are you sure?",
            "LINK_WILL_REMOVED": "The link will be removed.",
            "KEEP_LINK": "Keep",
            "CONFIRM_LINK_DELETE": "Yes, delete",
            "MOCK_IN_PROGRESS_TEXT": "In progress",
            "MOCK_AWAITING_SCORE_TEXT": "Test complete, awaiting scores",
            "MOCK_COMPLETED_SCORE_LABEL": "Score",
            "NO_TEST_TYPE_ERROR": "Error: This test is not associated with a 'Test type'. Please associate a 'Test type'.",
            "PRODUCTIVESKILL_SUBMIT_DISABLE_TOOLTIP": "You will be able to submit this activity when a teacher is added to your class",
            "READ_CONVERSATION": "Read conversation",
            "SEE_TOPICS": "See topics",
            "BACK_TO_ASSIGNMENTS": "Back to assignments",
            "SCREEN_READER": {
                "CROSS": "Close",
                "HELP": "Help",
                "SUBMIT_ANSWERS_FOR_MARKING": "Submit",
                "GOTO_NEXT_SCREEN": "Go to next screen",
                "GO_TO_UNIT_VIEW": "Go to unit view",
                "CLOSE_TOC": "Close table of contents",
                "GO_BACK_ASSIGNMENTS": "Go back to assignments' page",
                "OPEN_TOC": "Open table of contents",
                "DOWNLOADABLE_ITEM": "Downloadable item",
                "BOLD": "Bold",
                "ITALIC": "Italic",
                "UNDERLINE": "Underline",
                "GROUP_INFO": "Group Information",
                "CLOSE_GROUP_INFO": "Close pop-up for Group info",
                "OPEN_LINK": "Open link: ",
                "SHOW_LINK_OPTIONS": "Show link options",
                "CANCEL_DELETE_LINK": "Cancel link deletion",
                "STATUS_IN_PROGRESS": "Activity status: in progress",
                "ACTIVITY_SCREEN_STATUS": "Exercise {{currentScreen}} of {{totalScreens}}",
                "ACTIVITY": "Activity: {{activityName}}"
            }
        },
        "CREATE_USER_ANALYTICS": {
            "WELCOME_TEXT": "Welcome to your Cambridge One",
            "DESCRIPTION_TEXT": "We’re setting up the learning materials for you",
        },
        "_COMMON_ACROSS_PAGES": {
            "HEADER": {
                "MY_PROFILE": "My profile",
                "LOGOUT": "Log out",
                "CONTENT": "Content"
            }
        }
    },
    "TEACHER": {
        "PRODUCT_VIEW": {
            "BANNER_MESSAGE": "{{activatedProductTitles}} for {{bundleTitle}} activated",
            "PEAS_BANNER_MESSAGE": "{{peasBundleTitle}} activated",
            "PEAS_BANNER_MESSAGE_STARTED": "{{peasBundleTitle}} started",
            "SCREEN_READER": {
                "GO_BACK_BUNDLE": "Go back to learning materials page",
                "GO_BACK_CLASS_PAGE": "Go back to class materials page",
                "GO_BACK_DASHBOARD": "Go back to dashboard",
            }
        },
        "CREATE_ASSIGNMENTS": {
            "SELECT_CONTENT": "Select content",
            "MORE_INFORMATION": "More information",
            "UNIT_DEEPLINK_TOOLTIP_TEXT": "select one or more whole units to create a link to each of them (one link per unit)",
            "UNIT_DEEPLINK_TOOLTIP_TEXT_SPEAKING_COMPANION": "select one or more whole categories to create a link to each of them (one link per category)",
            "CUSTOM_DEEPLINK_TOOLTIP_TEXT": "select a list of lessons and/or activities to create a single custom link to all of them",
            "CUSTOM_DEEPLINK_TOOLTIP_TEXT_SPEAKING_COMPANION": "select a list of sub-categories and/or topics to create a single custom link to all of them",
            "BY_UNIT": "By unit",
            "BY_CATEGORY": "By category",
            "CUSTOMISED": "Customised",
            "MANAGE_CUSTOM_LINKS": "Manage custom links",
            "MAX_CUSTOM_LINKS_HEADING": "Maximum number of custom links created",
            "MAX_CUSTOM_LINKS_DESC": "Your class has already reached the maximum number of 150 custom links. Delete a custom link to create again.",
            "MAX_ASSIGNED_ACTIVITIES_HEADING": "Activities limit reached",
            "MAX_ASSIGNED_ACTIVITIES_DESC": "You have reached the limit of assigned activities and will need to delete old custom links before you can add more. Go to 'Manage custom links' to delete old links and free up space.",
            "VIEW_CUSTOM_LINKS": "View custom links",
            "NEXT": "Next",
            "UPDATE": "Update",
            "CHECK": "Check",
            "REVIEW": "REVIEW",
            "PREVIOUS": "Previous",
            "NEXT_ACTIVITY": "NEXT ACTIVITY",
            "ACTIVITIES": "activities",
            "ACTIVITY": "activity",
            "YOU_HAVE": "You have",
            "SELECTED": "selected",
            "ASSIGN_TO_CLASS": "Assign to:",
            "ASSIGN_TO_CLASS_SUCCESS": "assigned to",
            "NO_ITEMS_LEFT_TO_ASSIGN": ". No more content left to assign.",
            "FOC_NO_ITEMS_LEFT_TO_ASSIGN": ". No more content left to assign",
            "ALL_STUDENTS" : "all students",
            "ASSIGNMENT_NAME": "Assignment name",
            "LINK_NAME": "Link name",
            "ASSIGNMENT_DUE_DATE": "Assignment due date",
            "PREV": "Prev",
            "ASSIGN": "Assign",
            "CREATE": "Create",
            "CANCEL": "Cancel",
            "EDITED": "Edited",
            "CONFIRM_DELETE_MESSAGE": "Are you sure you want to delete?",
            "SET_ASSIGNMENT": "Set assignment",
            "CREATE_CUSTOM_LINK": "Create custom link",
            "EXIT": "Exit",
            "ASSIGN_NEW": "Assign new",
            "CREATE_NEW_ASSIGNMENT": "Create new assignment",
            "START_DATE_ASSIGN": "From {{startDate}} at {{startTime}}",
            "END_DATE_ASSIGN": "to {{endDate}} at {{endTime}}",
            "PREVIOUSLY_ASSIGNED": "Previously assigned",
            "DUE": "Due",
            "START_DATE": "Start date",
            "DUE_DATE": "Due date",
            "LOCK_CONTENT": "Lock access to assignment content after due date",
            "STUDENT_ACCESS": "Student access after due date",
            "ACCESS_LOCKED": "Locked",
            "ACCESS_UNLOCKED": "Unlocked",
            "NO_GROUP_INFO_TITLE":"This material includes collaborative activities",
            "NO_GROUP_INFO_MSG":"No groups have been created for this class yet. Create groups and add students to them so they can complete this activity",
            "NO_CUSTOM_LINKS_HEADING": "You have no custom links yet",
            "NO_CUSTOM_LINKS_DESC": "Select a list of lessons and/or activities to create a single custom link to all of them",
            "ADD_LINK": "Create link",
            "ADD_LINKS": "Create links",
            "RE_LINK": "Re-link",
            "DELETE": "Delete",
            "RULES_WARNING_HEADING": "Did you want to assign locked content?",
            "RULES_WARNING_TEXT": "These activities are locked by an access rule. If you assign them to your class they will automatically be unlocked to give your students access for the duration of the assignment",
            "VIEW_DETAILS": "View details",
            "HIDE_DETAILS": "Hide details",
            "VIEW_RULES_LIST": "View list of access rules",
            "LOCKED_FROM": "Locked from {{startDate}} at {{startTime}} to {{endDate}} at {{endTime}}",
            "AND": " and ",
            "ASSIGNMENT_CREATED": "Assignment created",
            "ASSIGNMENT_AND_RULE_CREATED": "Assignment and lock access rule created",
            "RULE_DUE_DATE_INFO": "until {{dueDate}}",
            "ASSIGNMENT_UPDATED": "Assignment updated",
            "ASSIGNMENT_AND_RULE_UPDATED": "Assignment and access rule updated",
            "REVIEW_ASSIGNMENT": "Review created assignments",
            "RETURN_PRESENTATION_PLUS": "Return to Presentation Plus",
            "RETURN_EBOOK": "Return to eBook",
            "SELECT_ALL": "Select all",
            "RULE_LIMIT_ERROR": "Limit reached: {{limit}} rules for {{componentName}}",
            "RULE_SIZE_ERROR": "Rule cannot be created",
            "RULE_LIMIT_ERROR_MESSAGE_1": "Your assignment has been created, but the lock access rule could not be applied.",
            "RULE_LIMIT_ERROR_MESSAGE_2": "To enable locking access after the due date, remove at least one rule linked to {{componentName}}",
            "RULE_LIMIT_EDIT_ERROR_MESSAGE": "Your assignment has been edited, but the lock access rule could not be applied.",
            "RULE_CREATION_ERROR": "Lock access rule could not be applied",
            "RULE_CREATION_ERROR_MESSAGE_1": "Your assignment has been created, but the lock access rule could not be applied due to a technical issue.",
            "RULE_CREATION_ERROR_MESSAGE_2": "Continue without it, or try again",
            "RULE_EDIT_ERROR_MESSAGE_1": "Your assignment has been edited, but the lock access rule could not be applied due to a technical issue.",
            "RULE_DELETE_ERROR": "Lock access rule could not be removed",
            "RULE_DELETE_ERROR_MESSAGE_1": "Your assignment has been updated, but the lock access rule could not be removed due to a technical issue.",
            "RULE_DELETE_ERROR_MESSAGE_2": "Continue without removing it, or try again",
            "RULE_UPDATE_ERROR": "Lock access rule could not be updated",
            "RULE_UPDATE_ERROR_MESSAGE_1": "Your assignment has been edited, but the lock access rule could not be updated due to a technical issue.",
            "RULE_UPDATE_ERROR_MESSAGE_2": "Continue without it, or update the lock rule manually",
            "CONTINUE_WITHOUT_LOCK": "Continue without locking",
            "DELETE_EXISTING_RULE": "Delete an existing rule",
            "CREATE_LOCK_RULE": "Create lock access rule",
            "CONTINUE_WITHOUT_REMOVING": "Continue without removing",
            "CONTINUE_WITHOUT_UPDATING": "Continue without updating the lock rule",
            "UPDATE_LOCK_RULE": "Update lock access rule",
            "DELETE_LOCK_RULE": "Delete lock access rule",
            "BACK_TO_ACTIVITIES": "Back to activities",
            "BACK_TO_TESTS": "Back to tests",
            "BACK_TO_ASSIGNMENT_DETAILS": "Back to assignment details",
            "BACK_TO_SELECT_STUDENTS": "Back to student selection",
            "BACK_TO_ASSIGNMENT_CREATION_SUMMARY": "Back to summary",
            "BACK_TO_ASSIGNMENTS": "Back to assignments",
            "KEEP_EDITING": "Keep editing",
            "ASSIGNMENT_SUMMARY": "Assignment summary",
            "ASSIGNMENT_CONTENT": "Assignment content", 
            "ASSIGNMENT_DETAILS": "Assignment details",
            "EDIT_ASSIGNMENT": "Edit",
            "DISABLED_EDIT_BUTTON_MESSAGE": "You need to have students in this class first before you can edit",
            "EDIT_ASSIGNMENT_INFO": "You are making changes to an active assignment, students will be notified.",
            "STUDENTS_TITLE": "Students",
            "STUDENTS": "students",
            "STUDENT": "student",
            "START_DATE_TIME": "Start date and time",
            "DUE_DATE_TIME": "Due date and time",
            "NAME": "Name",
            "WARNING_LEAVE_THIS_PAGE": "Are you sure you want to leave this page?",
            "WARNING_CANCEL": "Are you sure you want to cancel?",
            "WARNING_MODAL_TEXT": "All progress will be lost",
            "DUE_DATE_WARNING": "The due date is in the past",
            "DUE_DATE_WARNING_TEXT": "Change the due date to update the assignment",
            "EDIT_DUE_DATE": "Edit due date",
            "CANCEL_CHANGES": "Cancel changes",
            "GO_BACK": "No, go back",
            "GO_BACK_BUTTON": "Go back",
            "CONFIRM_CANCEL": "Yes, cancel",
            "CONFIRM_LEAVE_THIS_PAGE": "Yes, leave this page",
            "ENTER_ASSIGNMENT_DETAILS": "Enter assignment details",
            "SELECT_ALL_STUDENTS": "All students",
            "SELECT_STUDENTS": "Select students",
            "NO_LEARNER_PLACEHOLDER1": "You haven't added any students to this class yet",
            "NO_LEARNER_PLACEHOLDER2": "The assignment will be automatically set to students when they join the class",
            "VIEW_SUMMARY": "View summary",
            "CREATE_ANOTHER_ASSIGNMENT": "Create another assignment",
            "ASSIGNMENT_LIMIT_TITLE": "Assignment limit reached",
            "ASSIGNMENT_LIMIT_DESC": "You have reached the maximum number of assignments for this class. Please delete at least one assignment to create a new one",
            "CLOSE": "Close",
            "READ_CONVERSATION": "Read conversation",
            "ASSIGNMENT_LO_LIMIT_MODAL": {
                "LIMIT": "Limit reached",
                "WARNING_TEXT1": "You have reached the limit of assigned activities in the class",
                "WARNING_TEXT2": "Please delete an assignment to assign more activities",
                "LIMIT_LTI": "Activities limit reached",
                "WARNING_TEXT1_LTI": "You have reached the limit of assigned activities and will need to delete old custom links before you can add more.",
                "WARNING_TEXT2_LTI": "Go to 'Manage custom links' to delete old links and free up space",
                "MANAGE_CUSTOM_LINKS": "Manage custom links"
            },
            "UPDATED_CONTENT_BANNER": {
                "CONTENT_UPDATED_MESSAGE": "Assignment successfully updated",
                "DETAILS_UPDATED_MESSAGE": "Assignment successfully updated",
                "STUDENT_UPDATED_MESSAGE": "Students successfully updated",
                "CLOSE_SUCCESS_MESSAGE": "Close banner"
            },
            "SCREEN_READER": {
                "ENTER_LINK_NAME": "Enter link name",
                "ENTER_ASSIGNMENT_START_DATE": "Enter assignment start date",
                "ENTER_ASSIGNMENT_DUE_DATE": "Enter assignment due date",
                "SELECT_UNIT_DEEPLINK": "Select to create unit deeplinks",
                "SELECT_CUSTOM_DEEPLINK": "Select to create custom deeplinks",
                "SUBMIT_ANSWERS_FOR_MARKING": "Submit",
                "GOTO_NEXT_SCREEN": "Go to next screen",
                "OPEN_TOC": "Open table of contents",
                "GO_TO_UNIT_VIEW": "Go to unit view",
                "GO_BACK": "Go back to create assignment",
                "NEXT": "Next",
                "CANCEL_BUTTON": "Cancel Button",
                "CLOSE_POP_UP": "Close pop up",
                "CLOSE_SIDEBAR": "Close sidebar",
                "SELECT_LESSON": "Select lesson to create assignment",
                "LESSON_INCLUDED_SUCCESS": "Lesson is successfully included in assignment",
                "SELECT_ACTIVITY": "Select activity to create assignment",
                "ACTIVITY_INCLUDED_SUCCESS": "Activity is successfully included in assignment",
                "PROCESSING": "Processing",
                "NO_CUSTOM_LINKS_ICON": "No custom links icon",
                "NAVIGATE_BACK_TO_DASHBOARD": "Back to dashboard page",
                "NO_GROUP_WARNING": "No groups warning",
                "SELECT_UNIT": "Select Unit",
                "CLOSE_UNITVIEW_SIDEBAR": "Close table of contents",
                "GO_TO_COMPONENT_VIEW": "Go back to component selection page",
                "GO_TO_SELECT_CONTENT_VIEW": "Go back to select content page",
                "GO_BACK_TO_ACTIVITIES": "Go back to activities",
                "SELECT_STUDENT": "Select student",
                "ENTER_ASSIGNMENT_NAME": "Enter Assignment name"
            }
        },
        "_COMMON_ACROSS_PAGES": {
            "HEADER": {
                "JOIN_NEW_SCHOOL": "Join school",
                "CONTENT": "Content",
                "SCREEN_READER": {
                    "CAMBRDIGE_LOGO": "Cambridge One Home"
                },
                "HELP": "Help",
                "HELP_CENTRE": "Help centre",
                "TUTORIALS": "Tutorials",
                "UNDERSTANDING_CODES_AND_KEYS": "Understanding codes and keys",
                "ACTIVATING_COURSE_MATERIALS": "Activating course materials",
                "CREATING_A_CLASS": "Creating a class",
                "ADDING_STUDENTS_TO_A_CLASS": "Adding students to a class",
                "CREATING_ASSIGNMENTS": "Creating assignments",
            }
        },
        "CREATE_ACCESS": {
            "SELECT_ALL": "Select all",
            "CONTINUE": "Continue",
            "CONTENTS": "Contents",
            "RESET_SELECTION": "Re-set",
            "CLEAR_SELECTION": "Clear selection",
            "UPDATE": "Update",
            "SET_RULE_PAGE": {
                "PRODUCT_NAME": "Create a rule for {{productTitle}}",
                "PRODUCT_NAME_UPDATE": "Edit rule for {{productTitle}}",
                "RULE_SELECTION_MSG": "I want the selected content to",
                "UNLOCK_WARNING_MSG": "Unlock rules will override any existing or future lock rules",
                "LOCK": "Lock",
                "UNLOCK": "Unlock",
                "RULE_TITLE_TEXT": "Rule title (Optional)",
                "RULE_TITLE_PLACEHOLDER": "Enter a rule title",
                "TOOLTIP_TEXT": "You can use the Rule title to describe your rule (e.g. Mid-term content, Units 1-3, Restricted activities)",
                "SCHEDULE": "Schedule",
                "CLASS_PERIOD": "Class period:",
                "START_DATE_LABEL": "Start date",
                "SET_END_DATE_LABEL": "Set an End date",
                "END_DATE_LABEL": "End date",
                "STUDENTS_INFO": "Students ({{studentCount}})",
                "CANCEL": "Cancel",
                "SAVE": "Save",
                "SELECT_ALL": "Select all",
                "NO_LEARNER_PLACEHOLDER": "You haven't added any students to this class yet",
                "EXIT": "Exit",
                "CREATE_ANOTHER_RULE": "Create another rule",
                "LOCK_RULE_CREATED_MSG": "You have successfully locked the selected content for all students",
                "UNLOCK_RULE_CREATED_MSG": "You have successfully unlocked the selected content for all students",
                "LOCK_RULE_CREATED_MSG_INDIVIDUAL": {
                    "SINGULAR": "You have successfully locked the selected content for {{learnersCount}} student",
                    "PLURAL": "You have successfully locked the selected content for {{learnersCount}} students",
                },
                "UNLOCK_RULE_CREATED_MSG_INDIVIDUAL": {
                    "SINGULAR": "You have successfully unlocked the selected content for {{learnersCount}} student",
                    "PLURAL": "You have successfully unlocked the selected content for {{learnersCount}} students",
                },
                "RULE_UPDATED_MSG": "You have successfully updated this access rule",
                "ACCESS_RULE_CREATED_MSG": "Access rule created!",
                "ACCESS_RULE_UPDATED_MSG": "Access rule updated!",
                "CONTINUE_EDITING": "Continue editing",
                "ASSIGNMENTS_WARNING_HEADING": "This content is included in a current assignment. It can't be locked until that ends",
                "VIEW_DETAILS": "View details",
                "HIDE_DETAILS": "Hide details",
                "VIEW_ASSIGNMENTS": "View assignments list",
                "ASSIGNED_FROM": "Assigned from {{assignmentStartDate}} at {{assignmentStartTime}} to {{assignmentDueDate}} at {{assignmentDueTime}}",
                "LEAVE_THIS_PAGE": "Leave this page?",
                "LEAVE_CREATE_PAGE_MSG": "You have not finished creating this rule",
                "LEAVE_WITHOUT_SAVING": "Leave without saving",
                "BACK_TO_CREATING": "Back to creating",
                "LEAVE_EDIT_PAGE_MSG": "You have not finished editing this rule",
                "BACK_TO_EDITING": "Back to editing",
                "RULES_WARNING_HEADING": "This content has existing rules",
                "RULES_WARNING_TEXT": "The content you selected already has rules associated with it",
                "VIEW_RULES_LIST": "View detailed list of access rules",
                "LOCKED_FROM": "Locked from {{startDate}} at {{startTime}} to {{endDate}} at {{endTime}}",
                "AND": " and ",
                "UNLOCKED_FROM": "Unlocked from {{startDate}} at {{startTime}} to {{endDate}} at {{endTime}}",
                "NOTIFICATIONS": "Notifications",
                "NOTIFICATION_BEFORE_START_DATE": "Send a reminder to students on the day before the rule start date",
                "NOTIFICATION_ON_START_DATE": "Send a reminder to students on the rule start date",
                "NOTIFICATION_BEFORE_END_DATE": "Send a reminder to students on the day before the rule end date",
                "RULE_LIMIT_MSG": "You have reached the limit of {{ruleLimit}} rules allowed for",
                "RULES_EXCEED_HEADING": "Rule cannot be created",
                "MAX_RULE_SIZE": "You have reached the maximum number of rule items for this material",
                "GO_BACK": "Go back",
                "SCREEN_READER": {
                    "SELECT_STUDENT": "Select student",
                    "PROCESSING": "Processing",
                    "CLOSE": "Close"
                }
            },
            "SCREEN_READER": {
                "SELECT_ALL_UNIT": "Select all units",
                "SELECT_ALL_LESSON": "Select all lessons"
            },
            "UPDATE_CONTENTS_BANNER": {
                "UPDATE_MSG": "Selected content updated!",
                "SCREEN_READER": {
                    "CLOSE": "close"
                }
            }
        },
        "GRADE_ACTIVITY_SELECTION": {
            "PREVIEW_PART1": "Please deselect the activities you would like to exclude from grade calculation",
            "PREVIEW_PART2": "You can also view the activity by clicking the activity title",
            "SAVE": "Save",
            "WARNING_MODAL_TEXT1": "Are you sure you want to go back?",
            "CANCEL_WARNING_MODAL_TEXT": "Are you sure you want to cancel?",
            "WARNING_MODAL_TEXT2": "Any unsaved changes will be lost",
            "GO_BACK": "Yes, go back",
            "CONTINUE_EDITING": "No, continue editing",
            "NO_GO_BACK": "No, go back",
            "YES_CANCEL": "Yes, cancel",
            "CONFIRMATION_MODAL_HEADING": "Content selection updated",
            "CONFIRMATION_MODAL_TEXT": "You have selected {{selectedActivities}} out of {{totalActivities}} activities in {{materialName}}: {{componentName}}",
            "BACK_TO_GRADE_WEIGHTING": "Back to class grade settings",
            "SCREEN_READER": {
                "CLOSE": "Close"
            }
        },
        "GENERIC_ERROR_MODAL": {
            "ERROR_MODAL_TEXT": "Sorry, something went wrong. Your changes could not be saved",
            "TRY_AGAIN_BTN": "Try again",
            "SCREEN_READER": {
                "CLOSE": "close"
            }
        }
    },
    "_COMMON_ACROSS_MODULES": {
        "FOOTER": {
            "TERMS_OF_USE": "Terms of use",
            "PRIVACY_POLICY": "Privacy notice",
            "ACCESSIBILITY": "Accessibility",
            "SYSTEM_STATUS": "System status",
            "OUR_APPROACH": "Our approach",
            "HELP": "Help",
            "CAMBRDIGE_UNIVERSITY_PRESS": "Cambridge University Press & Assessment",
            "INSTITUTION_REQUEST": "Cambridge One for schools",
            "FAQ": "FAQs"
        }
    },
    "SHARED": {
        "ACTIVITY_QUESTION": {
            "SCREEN_READER": {
                "CROSS": "Close",
                "HELP": "Help",
            }
        },
        "COLLAB" : {
            "SHOW_INSTRUCTION": "Show instructions",
            "HIDE_INSTRUCTIONS": "Hide instructions",
            "TITLE" : "Collaborative Task",
            "MODAL_PLACEHOLDER" : "This is a collaborative task, where students assigned to a group work together to complete an activity. Students need to be in a group to do this",
            "DISABLE_GROUP_INFO_MSG" : "This is a collaborative activity. It can only be completed by students assigned to groups by a teacher",
            "ARCHIVED_SUBMITTED_LOCK_VERSION_MSG" : "This activity is now locked because the group that worked on it has been archived. You can still see past comments made by the group.",
            "ARCHIVED_LOCK_VERSION_MSG" : "The activity is now locked because the group that worked on this has now been archived.",
            "POST_BUTTON" : "Post",
            "NO_COMMENTS_LABEL": "No comments yet",
            "YOUR_COMMENT_LABEL": "Your comment",
            "LOAD_MORE_COMMENTS": "View previous comments",
            "LOADING_COMMENTS": "Loading",
            "ACTOR_TEACHER_LABEL": "Teacher",
            "READY": "Ready",
            "SUBMIT": "Submit",
            "ELAPSED_TIME": {
                "JUST_NOW": "Just now",
                'MINUTE_AGO': ' minute ago',
                'MINUTES_AGO': ' minutes ago',
                'HOUR_AGO': ' hour ago',
                'HOURS_AGO': ' hours ago',
                'DAY_AGO': ' day ago',
                'DAYS_AGO': ' days ago',
            },
            "SCREEN_READER": {
                "GROUP_INFO": "Group Information",
                "CLOSE_GROUP_INFO": "Close pop-up for Group info",
                "SCROLL_BTN_UP": "Scroll to top",
                "SCROLL_BTN_DOWN": "Scroll to bottom",
                "INFO": "Information"
            },   
            "ARE_YOU_READY_TO_SUBMIT": "Ready to submit?",
            "NO_FURTHER_CHANGES_ALLOWED_MESSAGE": "You are acting for all group members. Are you sure that this activity is now complete?",
            "CANCEL": "Cancel",
            "COMPLETE": "Yes, complete"
        },
        "CHANGES_NOT_SAVED": {
            "FORGIVE_US_TEXT": "Sorry …",
            "SORRY_SOMETHING_WRONG_TEXT": "Sorry, something went wrong",
            "SORRY_PROBLEM_AT_OUR_END_TEXT": "Sorry, there's a problem at our end. Please try again later",
            "SOMETHING_WENT_WRONG": "We're unable to submit your work at the moment",
            "LAST_SAVED": "Last saved",
            "PLEASE_TRY_AGAIN": "Please check you're online and try again",
            "OK": "OK",
            "RECORDING_NOT_SAVED": "Sorry, we're unable to save your recording at the moment. Don't worry, you won't lose your work unless you click on the exit button",
            "CHECK_TIPS": "Try the following",
            "FREE_SPACE": "Check you're online",
            "TIPS2": "Free up some space on your device",
            "PLEASE_CHECK_URL_LINK": "Please check the URL added and try again"
        },
        "SAVEALERT": {
            "CLOSE": "Close",
            "EXIT": "Yes, I want to leave",
            "STAY": "Stay on page",
            "LOOSE_WORK_WARNING_MESSAGE": "You will lose your work if you leave now",
            "ARE_YOU_SURE": "Are you sure you want to leave the activity?",
            "ARE_YOU_SURE_SCOMP": "Are you sure you want to leave?",
            "LOOSE_WORK_WARNING_MESSAGE_SCOMP": "You'll need to start again next time",
            "YES_LEAVE": "Yes, leave",
            "NO_STAY": "No, stay"
        },
        "COOKIES_BANNER": {
            "WEBSITE_USES_COOKIES": "This website uses cookies. For more information, please visit the ",
            "PRIVACY_POLICY": "Privacy notice",
            "ACCEPT": "Accept cookies"
        },
        "RESULT_SCREEN": {
            "YOU_SCORED":"You scored",
            "MARKS_OUT_OF":"out of",
            "CONTINUE": "Next activity",
            "REVIEW": "Review answers",
            "TRY_AGAIN": "Try again",
            "START_AGAIN": "Start again"
        },
        "GENERIC_LTI": {
            "PREVIEW_BUTTON": "Preview",
            "LAUNCH_BUTTON" : "Launch",
            "REVIEW_BUTTON" : "Review",
            "LITMUS_TEST_INSTRUCTION": "We are making some changes to these tests, so they will look a little different. If you need help, you can find it on ",
            "CAMBRIDGE_ONE": "Cambridge One",
            "INSTRUCTIONS_MSG1": "This test is designed for desktop",
            "INSTRUCTIONS_MSG2": "To see the questions in <strong>{{activityName}}</strong>, choose ‘Preview’, which will open a new window.",
            "INSTRUCTIONS_MSG3": "Close the window to return here and assign the test.",
            "INSTRUCTIONS_MSG4": "Close the window to return here and create a rule.",
            "INSTRUCTIONS_MSG5": "Close the window to return here and edit tests included in score calculation.",
            "LAUNCH_INSTRUCTIONS": "To begin <strong>{{activityName}}</strong>, choose ‘Launch’, and it will open in a new window.",
            "SINGLE_ATTEMPT_INSTRUCTIONS": "Please be aware that you will only have <strong>one attempt</strong> to complete this test.",
            "REVIEW_INSTRUCTIONS" : "To review <strong>{{activityName}}</strong>, choose ‘Review’, and it will open in a new window.",
            "REVIEW_LAST_ATTEMPT": "To review your last attempt, choose ‘Review’, and it will open in a new window.",
            "PREVIEW_INSTRUCTIONS": "To see the questions in <strong>{{activityName}}</strong>, choose ‘Preview’, which will open a new window.",
            "LOADER_TEXT": "Your page is loading. This might take a few seconds.",
            "LITMUS_DOWN_TEXT": "We can't take you to this task right now",
            "LITMUS_DOWN_MSG1": "Due to maintenance taking place this task is currently unavailable. Please try again later",
            "LITMUS_DOWN_MSG2": "Due to maintenance taking place this task is currently unavailable. You can still assign this test to a class",
            "LITMUS_DOWN_CLOSE": "Close",
            "LITMUS_DOWN_SCREEN_MSG1": "Due to maintenance taking place this task is currently unavailable. Please try again later",
            "LITMUS_DOWN_SCREEN_BUTTON": "Go to Dashboard",
            "LEARNER_REVIEW_ASSIGNMENT": {
                "INSTRUCTIONS" : "Review the answers to your last attempt of <strong>{{activityName}}</strong>, then choose Launch if you want to take the test again",
                "LAST_ATTEMPT_INSTRUCTIONS": "To review <strong>{{activityName}}</strong>, choose ‘Review’, and it will open in a new window.",
                "ATTEMPTS_LEFT" : {
                    "NONE": "You have no more attempts left",
                    "SINGULAR": "You have <strong>{{attemptsLeft}}</strong> attempt left",
                    "PLURAL": "You have <strong>{{attemptsLeft}}</strong> attempts left",
                  },
                  "PRACTICE_INSTRUCTIONS": "Review the answers in your last attempt of <strong>{{activityName}}</strong>, then do the recommended practice before you launch your next attempt",
                  "VIEW_RECOMMENDED_PRACTICE": "View Recommended Practice"
            },
            "BROWSER_NOT_SUPPORTED": {
                "HEADING": "Browser not supported",
                "DESCRIPTION": "Sorry, but we are not able to launch this test in Safari. You will need to use Google Chrome instead",
                "CLOSE": "Close pop up for browser not supported",
                "CLOSE_BTN": "Close"
            },
            "SCREEN_READER": {
                "PREVIEW_BUTTON": "Preview",
                "LAUNCH_BUTTON" : "Launch",
                "REVIEW_BUTTON" : "Review",
                "DESIGNED_FOR_DESKTOP": "Designed for desktop img"
            }
        },
        "ATTEMPTS_EXCEEDED": {
            "ATTEMPT_LIMIT_MSG1": "You have no more attempts",
            "ATTEMPT_LIMIT_MSG2": {
                "NONE": "You have already used the {{attemptAllowed}} attempts available to you for this test.",
                "SINGULAR": "You have already used the {{attemptAllowed}} attempt available to you for this test.",
                "PLURAL": "You have already used the {{attemptAllowed}} attempts available to you for this test.",
              },
            "ATTEMPT_LIMIT_MSG3": "You have already used all the attempts available to you for this test.",
            "NAVIGATE_TO_DASHBOARD_BUTTON": "Go to dashboard",
        },
        "AUDIO_PROMPT": {
            "FORWARD_BUTTON": "Forward 5 seconds",
            "REWIND_BUTTON": "Rewind 5 seconds",
            "PLAY": "Play",
            "PAUSE": "Pause",
            "SCREEN_READER": {
                "PROGRESS_BAR": "Seek"
            }
        },
        "SUBMIT_REDIRECTION_PAGE": {
            "MY_HOMEWORK_BUTTON": "Back to My Homework",
            "MY_ASSIGNMENTS_BUTTON": "Back to My Assignments",
            "HEADING_TEXT": "Well done!",
            "SUB_HEADING_1": "You have successfully completed <strong>{{testName}} (Attempt No. {{submitCount}})</strong>",
            "SUB_HEADING_2": "Keep learning and we'll notify you when your results are ready",
            "ATTEMPT_DESCRIPTION_1": "You don't have any attempts left to retake the test",
            "ATTEMPT_DESCRIPTION_2": "After this, you have <strong>{{remainingAttempt}}</strong> more attempt(s)",
            "GREEN_TICK_ICON": "Green tick icon"
        },
        "LO_RENDERER": {
            "BACK": "Back",
            "BACK_TO_ASSIGNMENT_SUMMARY": "Back to summary",
            "CANCEL": "Cancel",
            "NO_ACTIVITY_PREVIEW_PART1": "Select options from the menu to create a rule",
            "NO_ACTIVITY_PREVIEW_PART2": "Click on any title to view the content",
            "CUSTOM_LINK_DELETION_SUCCESS": "Successfully deleted custom link",
            "EXPIRED_CLASS_BANNER": "This class has expired. You can still view the activities included, but you cannot make any changes",
            "ENDED_CLASS_BANNER": "This class has ended. To edit activities included, reactivate the class first",
            "DELETED_CLASS_BANNER": "This class has been deleted. You can still view the grade settings for the class, but you cannot make any changes",
            "REACTIVATE": "Reactivate",
            "REACTIVATED_MESSAGE": "Class reactivated until {{classEndDate}}",
            "REACTIVATE_CLASS_HEADING": "Reactivate class",
            "CHANGE_CLASS_NAME": "Change class name",
            "CHANGE_STARTING_DATE": "Change start date",
            "CHANGE_ENDING_DATE": "Change end date",
            "CLASS_FORM_END_DATE_ERROR": "End date is required",
            "CLASS_FORM_DATES_ERROR": "Oops, looks like there's an error in this date range. Please check and try again",
            "CLASS_FORM_CHANGE_END_DATE_ERROR": "Extend the end date to reactivate this class",
            "REACTIVATION_PROGRESS_SYNCING_MESSAGE" : "Reactivation could take some time as we synchronise your students' progress to give you the full picture.",
            "WARNING_LEAVE_THIS_PAGE": "Are you sure you want to leave this page?",
            "WARNING_MODAL_TEXT": "All progress will be lost",
            "GO_BACK": "No, go back",
            "CONFIRM_LEAVE_THIS_PAGE": "Yes, leave this page",
            "SCREEN_READER": {
                "BACK": "Go Back",
                "CLOSE": "Close",
                "TOGGLE_TOC": "Open table of contents",
                "CLOSE_ACTIVITY": "Close Activity",
                "NAVIGATE_TO_MANAGE_ACCESS": "Navigate to manage students access"
            },
            "TEACHER_TRAINING_MSG": "This course can be found in <strong>My training</strong>",
            "ASSIGNMENTS_ONLY_BANNER": {
                "DESC": "This material can only be completed by students when you unlock or assign it",
                "DONT_SHOW_AGAIN": "Don't show again",
                "CLOSE": "Close"
            }
        },
        "CONTENT_ACCESS": {
            "BACK": "Back",
            "RULE": {
                "CONTENT_LOCKED": "Content locked",
                "NO_ACCESS": "You don't have access to this content",
                "NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT": "This content will be available to you when your teacher gives you access",
                "TIME_RANGE_START": "It will be available to you from <strong>{{startDate}} at {{startTime}}</strong> ",
                "TIME_RANGE_END": "to <strong>{{endDate}} at {{endTime}}</strong>"
            },
            "SCREEN_READER": {
                "LOCKED": "Locked",
                "BACK": "Back"
            }
        },
        "SCOMP_VIEW": {
            "BACK": "Back",
            "CONTENT_ACCESS": {
                "CONTENT_LOCKED": "Content locked",
                "NO_ACCESS": "You don't have access to this content",
                "NO_ACCESS_ASSIGNMENT_ONLY_PRODUCT": "This content will be available to you when your teacher gives you access",
                "TIME_RANGE_START": "It will be available to you from <strong>{{startDate}} at {{startTime}}</strong> ",
                "TIME_RANGE_END": "to <strong>{{endDate}} at {{endTime}}</strong>",
                "GO_BACK": "Go back",
                "SCREEN_READER": {
                    "CLOSE_POPUP": "Close popup",
                    "LOCKED": "Locked"
                }
            }
        }
    },
    "HTML_META" : {
        'LEARNERLEARNINGPATH' : {
            'TITLE' : '| Cambridge One',
            'DESCRIPTION' : 'Choose an item to learn or pick up where you last left off.'
        },
        'TEACHERLEARNINGPATH' : {
            'TITLE' : '| Cambridge One',
            'DESCRIPTION' : 'View learning materials available for teaching your students.'
        },
        'LEARNINGPATH' : {
            'TITLE' : '| Cambridge One',
            'DESCRIPTION' : 'Choose an item to learn or pick up where you last left.'
        },
        'MAIN' : {
            'CUSTOM_TITLE' : ' | Cambridge One',
            'TITLE' : 'Cambridge One | Cambridge University Press',
            'DESCRIPTION' : 'Cambridge One is a mobile-friendly learning environment for English language learners and teachers.'
        },
        'WARNING_MESSAGE': {
            'TITLE': 'Warning message - Exceeded attempts | Cambridge One'
        },
        'ASSIGNMENT_DETAILS': {
            'TITLE': 'Assignment details',
            'DESCRIPTION': 'Enter assignment details'
        },
        'CREATE_ASSIGNMENT': {
            'TITLE' : 'Create assignment',
            'DESCRIPTION': 'Select content to include in the assignment'
        },
        'CREATE_CUSTOM_LINK': {
            'TITLE' : 'Create content link of',
            'DESCRIPTION': 'Select content to include in the content link'
        },
        'SELECT_STUDENTS': {
            'TITLE': 'Select students',
            'DESCRIPTION': 'Select students for the assignment'
        },
        'ASSIGNMENT_SUMMARY': {
            'TITLE': 'Assignment summary',
            'DESCRIPTION': 'Check the assignment details you selected'
        },
        'EDIT_ASSIGNMENT': {
            'TITLE': 'Assignment summary',
            'DESCRIPTION': 'Edit the assignment'
        },
        'ASSIGNMENT_CONTENT': {
            'TITLE': 'Edit assignment',
            'DESCRIPTION': 'Select content to include in the assignment'
        },
        'CREATE_RULE': {
            'TITLE': 'Create a rule for ',
            'DESCRIPTION': 'Select content to create an access rule'
        },
        'UPDATE_RULE': {
            'TITLE': 'Edit the rule for ',
            'DESCRIPTION': 'Select content for the access rule'
        },
        "SCOMP_PRODUCT": {
            "TITLE": "Speaking Companion",
            "DESCRIPTION": "Choose a topic to practice speaking English with Cambridge One AI speaking companion"
        },
        "SCOMP_ACTIVITIES": {
            "TITLE": "Speaking Companion activities",
            "DESCRIPTION": "Choose a topic to practice speaking English with Cambridge One AI speaking companion"
        },
        "SCOMP_ACTIVITY_VIEW": {
            "TITLE": "Speaking Companion | {{ActivityName}}",
            "DESCRIPTION": "Practice speaking English with Cambridge One AI Speaking Companion"
        }
    }
}
module.exports = Object.assign(translationJsonObj, translationJson);
